import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
} from "reactstrap";
import { Button } from "ui-kit-takeat";

function BrandSetDefaultModal({ isOpen, toggle, brand, onConfirm, saving }) {
  if (!brand) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Tornar marca padrão</ModalHeader>
      <ModalBody>
        <Container>
          Tornar <b>{brand.fantasy_name}</b> a marca padrão?
          <p style={{ marginTop: 8, color: "#6c6c6c" }}>
            O CNPJ fiscal do restaurante passará a ser o dessa marca.
          </p>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button
          title="Cancelar"
          buttonColor="#6c757d"
          onClick={toggle}
          containerStyles={{ height: 36 }}
        />
        <Button
          title={saving ? "Salvando..." : "Confirmar"}
          buttonColor="#FFB32F"
          onClick={onConfirm}
          disabled={saving}
          containerStyles={{ height: 36 }}
        />
      </ModalFooter>
    </Modal>
  );
}

export default BrandSetDefaultModal;
